import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { addHours } from "date-fns";
import { z } from "zod";

import { TokenKeys } from "@/util/TokenKeys";
import { CenteredLoader } from "@/components/plugin-shared/centered-loader";

const handoverSearchSchema = z.object({
  token: z.string().optional(),
  redirect: z.string().optional(),
});

export const Route = createFileRoute("/handover")({
  validateSearch: (search) => handoverSearchSchema.parse(search),
  component: Handover,
});

function Handover() {
  const { token, redirect } = Route.useSearch();
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies([TokenKeys.AccessToken]);

  useEffect(() => {
    if (
      typeof token === "string" &&
      typeof cookies[TokenKeys.AccessToken] !== "string"
    ) {
      setCookie(TokenKeys.AccessToken, token, {
        expires: addHours(new Date(), 1),
      });
    }
    if (typeof redirect === "string") {
      // Browser-safe base64 decode (atob handles the base64 input the
      // sender produced via Buffer.from(...).toString("base64")).
      const decoded = window.atob(redirect);
      window.location.href = decoded;
    } else {
      navigate({ to: "/", replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, redirect]);

  return <CenteredLoader />;
}
